(function () {
  var ck = (window.ck = window.ck || { pages: {}, assets: {} });
  var html = document.documentElement;
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)');
  var splits = [];
  var observers = [];
  var magneticReady = false;
  var tiltReady = false;

  function reduceMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function reveal(el) {
    var inView = false;
    var anim = null;

    var split = window.SplitText.create(el, {
      type: 'lines',
      mask: 'lines',
      linesClass: 'ck-line',
      autoSplit: true,
      onSplit: function (self) {
        anim = window.gsap.from(self.lines, {
          yPercent: 110,
          duration: 0.9,
          delay: 0.05,
          ease: 'power3.out',
          stagger: 0.09,
          paused: !inView
        });
        el.classList.add('ck-split-done');
        return anim;
      }
    });
    splits.push(split);

    var io = new IntersectionObserver(
      function (entries) {
        if (!entries[0].isIntersecting) return;
        inView = true;
        if (anim) anim.play();
        io.disconnect();
      },
      { rootMargin: '0px 0px -8% 0px' }
    );
    io.observe(el);
    observers.push(io);
  }

  function initReveals() {
    var targets = Array.prototype.slice.call(
      document.querySelectorAll('main .ck-display, main .ck-h1, main .ck-h2')
    );

    if (reduceMotion() || !window.gsap || !window.SplitText) {
      targets.forEach(function (el) {
        el.classList.add('ck-split-done');
      });
      return;
    }

    window.gsap.registerPlugin(window.SplitText);

    var fontsReady = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
    var timeout = new Promise(function (resolve) {
      setTimeout(resolve, 2000);
    });

    Promise.race([fontsReady, timeout]).then(function () {
      targets.forEach(function (el) {
        if (!el.isConnected) return;
        if (el.hasAttribute('data-ck-no-split') || !el.getClientRects().length || !el.textContent.trim()) {
          el.classList.add('ck-split-done');
          return;
        }
        reveal(el);
      });
    });
  }

  function initMagnetic() {
    if (magneticReady || !window.gsap) return;
    magneticReady = true;

    var SELECTOR = '.ck-btn--primary, .ck-btn--secondary, [data-ck-magnetic]';
    var current = null;
    var moveX = null;
    var moveY = null;
    var moveSkew = null;

    function release() {
      if (!current) return;
      window.gsap.to(current, {
        x: 0,
        y: 0,
        skewX: 0,
        scale: 1,
        duration: 0.8,
        ease: 'elastic.out(1, 0.45)',
        overwrite: true
      });
      current = null;
    }

    function clamp(value, limit) {
      return Math.max(-limit, Math.min(limit, value));
    }

    document.addEventListener('pointermove', function (event) {
      if (reduceMotion() || !finePointer.matches) {
        release();
        return;
      }
      if (current && !current.isConnected) current = null;

      var btn = event.target instanceof Element ? event.target.closest(SELECTOR) : null;
      if (btn && (btn.hidden || btn.disabled || btn.classList.contains('ck-btn--disabled'))) btn = null;

      if (btn !== current) {
        release();
        current = btn;
        if (btn) {
          moveX = window.gsap.quickTo(btn, 'x', { duration: 0.5, ease: 'power3.out' });
          moveY = window.gsap.quickTo(btn, 'y', { duration: 0.5, ease: 'power3.out' });
          moveSkew = window.gsap.quickTo(btn, 'skewX', { duration: 0.5, ease: 'power3.out' });
          if (!btn.hasAttribute('data-ck-magnetic')) {
            window.gsap.to(btn, { scale: 1.04, duration: 0.3, ease: 'power2.out', overwrite: 'auto' });
          }
        }
      }

      if (!btn) return;

      var rect = btn.getBoundingClientRect();
      var centerX = rect.left + rect.width / 2 - window.gsap.getProperty(btn, 'x');
      var centerY = rect.top + rect.height / 2 - window.gsap.getProperty(btn, 'y');
      var card = btn.hasAttribute('data-ck-magnetic');
      var dx = clamp((event.clientX - centerX) * (card ? 0.06 : 0.3), card ? 8 : 14);
      var dy = clamp((event.clientY - centerY) * (card ? 0.08 : 0.35), card ? 6 : 10);

      moveX(dx);
      moveY(dy);
      moveSkew(card ? 0 : clamp(dx * 0.25, 3));
    });

    html.addEventListener('pointerleave', release);
  }

  function initTilt() {
    if (tiltReady) return;
    tiltReady = true;

    var current = null;
    var frame = 0;

    function reset(el) {
      if (!el) return;
      el.style.setProperty('--rx', '0deg');
      el.style.setProperty('--ry', '0deg');
    }

    document.addEventListener('pointermove', function (event) {
      if (reduceMotion() || !finePointer.matches) return;
      var el = event.target instanceof Element ? event.target.closest('[data-ck-tilt]') : null;
      if (el !== current) {
        reset(current);
        current = el;
      }
      if (!el || frame) return;
      var x = event.clientX;
      var y = event.clientY;
      frame = requestAnimationFrame(function () {
        frame = 0;
        if (!current) return;
        var rect = current.getBoundingClientRect();
        var px = (x - rect.left) / rect.width - 0.5;
        var py = (y - rect.top) / rect.height - 0.5;
        current.style.setProperty('--ry', (px * 10).toFixed(2) + 'deg');
        current.style.setProperty('--rx', (-py * 8).toFixed(2) + 'deg');
      });
    });

    html.addEventListener('pointerleave', function () {
      reset(current);
      current = null;
    });
  }

  ck.pages.fx = {
    init: function () {
      initReveals();
      initMagnetic();
      initTilt();
    },
    destroy: function () {
      splits.forEach(function (split) {
        split.revert();
      });
      observers.forEach(function (io) {
        io.disconnect();
      });
      splits = [];
      observers = [];
    }
  };
})();
